import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isActiveOrganization: false,
    currentOrganization: null,
}

const organizationSlice = createSlice({
    name: 'organization',
    initialState,
    reducers: {
        fetchingOrganizationSuccess: (state, action) => {
            state.isActiveOrganization = true;
            state.currentOrganization = action.payload;
        },
        fetchingOrganizationReset: (state) => {
            state.isActiveOrganization = false;
            state.currentOrganization = null;
        },
    }
});

export const { fetchingOrganizationSuccess, fetchingOrganizationReset } = organizationSlice.actions;

export default organizationSlice.reducer;